export const templateTypes = {
    inviteEmployerRep_BYTE: 'inviteEmployerRep_BYTE',
    inviteEmployerRep_BYEMPREP: 'inviteEmployerRep_BYEMPREP',
    inviteEmployerRep: 'inviteEmployerRep',
    requestPasswordReset: 'requestPasswordReset',
    deleteEmployerRep: 'deleteEmployerRep',
    creditsEmployer: 'creditsEmployer',
    creditUsageInPercentage: 'creditUsageInPercentage',
    atsIntegration: 'atsIntegration',
    employerAtsIntegration: 'employerAtsIntegration',
    aiNotifications: 'aiNotifications',
    completeJobDefinition: 'completeJobDefinition',
    profileEmployer: 'profileEmployer',
    publicPositionNotifications: 'publicPositionNotifications',
    contactCandidateLinkedinInmail: 'contactCandidateLinkedinInmail',
    positionFeedbackRequestToEmployerRep: 'positionFeedbackRequestToEmployerRep',
    paycorSystemNotifications: 'paycorSystemNotifications',
};
